import { SafeBaseObject } from "@app/core/models/base-object.models"
import { DateTime } from "luxon"

export class ResSuggested extends SafeBaseObject {
    suggestedItemID = 0
    suggestedItemTypeID = 0
    suggestedItemType = ''
    bkgID = 0
    itineraryDate = DateTime.invalid('empty')
    groupID = 0
    guestID = 0
    serviceIDFrom = 0
    serviceNameFrom = ''
    optionIDFrom = 0
    optionNameFrom = ''
    experienceIDFrom = 0
    experienceNameFrom = ''
    experienceTemplateHdrIDFrom = 0
    experienceTemplateNameFrom = ''
    propertyIDFrom = 0
    propertyFrom = ''
    serviceIDTo?: number
    serviceNameTo = ''
    optionIDTo?: number
    optionNameTo = ''
    experienceIDTo?: number
    experienceNameTo?: string
    experienceTemplateHdrIDTo = 0
    templateNameTo = ''
    propertyIDTo?: number
    propertyTo = ''
    status = 'A'
    productType = ''

    productIDTo?: number
    productNameTo = ''
    productCityID?: number
    cityTo = ''
    productSupplierID?: number
    supplierNameTo = ''
    serviceTypeIDTo?: number
    serviceTypeNameTo = ''
    bedTypeFrom = ''
    mealPlanFrom = ''
    bedTypeTo = ''
    mealPlanTo = ''

    constructor(data?: any) {
        super()
        this.updateData(data)
    }
}

export interface IResApiGetSuggestedItems {
    ServiceID?: number
    OptionID?: number
    ExperienceTemplateHdrID?: number
    PropertyID?: number
    OptionNameTo?: string
    ProductNameTo?: string
}

export class ResSuggestedType extends SafeBaseObject {
    suggestedItemTypeID = 0
    suggestedItemType = ''

    constructor(data?: any) {
        super()
        this.updateData(data)
    }
}

export interface IResApiManageSuggestedItems {
    SuggItem?: IResApiManageSuggestedItem[]
    Reset?: string
    BkgID?: number
}

export interface IResApiManageSuggestedItem {
    SuggestedItemID?: number,
    SuggestedItemTypeID?: number,
    BkgID?: number,
    ItineraryDate?: DateTime,
    GroupID?: number,
    GuestID?: number,
    ServiceIDFrom?: number,
    OptionIDFrom?: number,
    ExperienceIDFrom?: number,
    ExperienceTemplateHdrIDFrom?: number,
    PropertyIDFrom?: number,
    ServiceIDTo?: number,
    OptionIDTo?: number,
    ExperienceIDTo?: number,
    ExperienceTemplateHdrIDTo?: number,
    PropertyIDTo?: number,
    ServiceTypeIDTo?: number,
    Status?: string
    BedType?: string,
    MealCod?: string,
    BedTypeFrom?: string,
    MealPlanFrom?: string,
    BedTypeTo?: string,
    MealPlanTo?: string,
}

export interface IRescomApiGetExperiences {
    ExperienceID?: number
    ExperienceName?: string
    ExperienceTypeID?: number
    CityID?: number
    CompanyFilter?: number
    PageSize?: number
    CountryCod?: string
}

export class RescomExperience extends SafeBaseObject {
    experienceID = 0
    experienceCode = ''
    experienceName = ''
    experienceTypeID = 0
    experienceType = ''
    cityID = 0
    city = ''
    minPax?: number
    maxPax?: number
    shortDescription = ''
    shortDescriptionAI = ''
    description = ''
    descriptionAI = ''
    notes = ''
    internalNotes = ''
    // companies: ResAdmExperienceCompany[] = []
    companiesToString = ''
    startDate = DateTime.invalid('empty')
    endDate = DateTime.invalid('empty')
    webSiteVisibilityFrom = DateTime.invalid('empty')
    webSiteVisibilityTo = DateTime.invalid('empty')
    lumpSum = false
    isMonoTemplate = false
    minBkgDay?: number
    duration?: number
    shortDescriptionAIMkt = false
    descriptionAIMkt = false
    usageTimeIDs?: string
    included?: string
    notIncluded?: string
    hasTemplate = true
    status = 'A'
    supplierID?: number

    constructor(data: any) {
        super();
        this.updateData(data);
        // if (data.Companies) this.companies = data.Companies.map((company: any) => new ResAdmExperienceCompany(company));
        // if (this.companies.length > 0) this.companiesToString = this.companies.map((company: ResAdmExperienceCompany) => company.companyName).join(', ');
    }
}

export class ResSuggestedBookingServices extends SafeBaseObject {
    serviceID = 0
    serviceName = ''
    optionID = 0
    optionName = ''
    serviceTypeID = 0
    itineraryDate = DateTime.invalid('empty')
    cityID = 0
    countryCod = ''

    constructor(data?: any) {
        super()
        this.updateData(data)
    }
}

export interface IResApiManageAlternativeUpgradeSuggestedItem {
    BkgID: number
    Item: IResApiManageAlternativeUpgradeSuggestedItemRow[]
}

export interface IResApiManageAlternativeUpgradeSuggestedItemRow {
    ItineraryDate?: DateTime
    GuestCod?: number
    BookedServiceID?: number
    BookedOptionID?: number
    ServiceIDTo?: number
    OptionIDTo?: number
    BedTypeCod?: string
    MealPlanCod?: string
    NewSellingPrice?: number
    Margin?: number
}

export interface IResApiUpdateAlternativeUpgradeSuggestedItem {
  BkgID: number
  SuggestedItemList: IResApiUpdateAlternativeUpgradeSuggestedItemRow[]
}

export interface IResApiUpdateAlternativeUpgradeSuggestedItemRow {
  SuggestedItemPriceDetailID: number
  SuggestedItemID: number
  NewSellingPrice: number
  Margin: number
  ForcedPrice: string
  Cost: number
  CostTax: number
  CostCurrency: string
  IncludeVAT: string
}
